// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___oPbWx","overlayModal":"style__overlayModal___3FANR","overlayModalInner":"style__overlayModalInner___A9cN6","overlayCloseButton":"style__overlayCloseButton___3wnfM","overlayModalTitle":"style__overlayModalTitle___2a-KZ","overlayModalText":"style__overlayModalText___15h4n","overlayModalTextBold":"style__overlayModalTextBold___zUeKt","overlayModalButtons":"style__overlayModalButtons___2lR_n","overlayModalButtonsItem":"style__overlayModalButtonsItem___1Tx1U","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___2hpvi","buttonActive":"style__buttonActive___Ano_0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-imagemaxtags/style.css
// module id = 813
// module chunks = 0